export const portfolio = [
  {
    id: 1,
    slug: 'branding-identity',
    title: 'Branding identity.',
    category: 'MULTIMEDIA',
    description:
      'A full branding package covering logo variations, typography, color palette, and visual direction across digital and print touchpoints.',
    longDescription:
      'A full branding package for Chef Damz covering logo variations, typography, color palette, and visual direction across digital and print touchpoints.',
    clientName: 'Chef Damz',
    websiteUrl: '#',
    image: '/img/branding.jpg',
    galleryImages: [
      { url: '/img/aboutimage.png', label: 'Portrait', size: 'tall' },
      { url: '/img/branding.jpg', label: 'Brand Mockup', size: 'wide' },
      { url: '/img/brologo.png', label: 'Logo', size: 'square' },
      { url: '/img/Artboard 7.png', label: 'Poster', size: 'tall' },
      { url: '/img/Untitled-7 [Recovered]-02.png', label: 'Packaging', size: 'wide' },
      { url: '/img/Vertical Logo 2.png', label: 'Application', size: 'square' },
      { url: '/img/Untitled-7 [Recovered]-03.png', label: 'Collateral', size: 'wide' },
      { url: '/img/riyologo.png', label: 'Mark', size: 'square' },
    ],
    detailFields: [
      { label: 'Portrait', value: '/img/aboutimage.png', type: 'image', size: 'tall' },
      { label: 'Brand Mockup', value: '/img/branding.jpg', type: 'image', size: 'wide' },
      { label: 'Logo', value: '/img/brologo.png', type: 'image', size: 'square' },
      { label: 'Poster', value: '/img/Artboard 7.png', type: 'image', size: 'tall' },
      { label: 'Packaging', value: '/img/Untitled-7 [Recovered]-02.png', type: 'image', size: 'wide' },
      { label: 'Application', value: '/img/Vertical Logo 2.png', type: 'image', size: 'square' },
      { label: 'Collateral', value: '/img/Untitled-7 [Recovered]-03.png', type: 'image', size: 'wide' },
      { label: 'Mark', value: '/img/riyologo.png', type: 'image', size: 'square' },
    ],
    year: '2025',
    industry: 'Multimedia',
    direction: 'Brand Identity',
  },
  {
    id: 2,
    slug: 'fintech-dashboard',
    title: 'FinTech Dashboard',
    category: 'Web App',
    description: 'A comprehensive dashboard for a financial institution with real-time data visualization.',
    longDescription:
      'A comprehensive dashboard for a financial institution with real-time data visualization, KPI tracking, and secure reporting workflows.',
    clientName: 'Finance Corp',
    websiteUrl: 'https://demo.raadsotech.com',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop',
    galleryImages: [
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop',
    ],
    detailFields: [
      { label: 'Deliverables', value: 'Product Dashboard', type: 'text' },
      { label: 'Live URL', value: 'https://demo.raadsotech.com', type: 'url' },
    ],
    year: '2025',
    industry: 'Financial Technology',
    direction: 'Product Dashboard',
  },
  {
    id: 3,
    slug: 'e-commerce-platform',
    title: 'E-Commerce Platform',
    category: 'E-Commerce',
    description: 'A modern e-commerce solution with seamless payment integration and inventory management.',
    longDescription:
      'A modern e-commerce solution with seamless payment integration, inventory management, and admin analytics.',
    clientName: 'Retail Group',
    websiteUrl: 'https://shop.raadsotech.com',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=800&auto=format&fit=crop',
    galleryImages: [
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=800&auto=format&fit=crop',
    ],
    detailFields: [
      { label: 'Platform Scope', value: 'Storefront + Admin Panel', type: 'text' },
      { label: 'Store URL', value: 'https://shop.raadsotech.com', type: 'url' },
    ],
    year: '2024',
    industry: 'Retail & Commerce',
    direction: 'Platform Development',
  },
  {
    id: 4,
    slug: 'healthcare-portal',
    title: 'Healthcare Portal',
    category: 'Web Portal',
    description:
      'A secure patient portal for healthcare providers with appointment booking and telemedicine capabilities.',
    longDescription:
      'A secure patient portal for healthcare providers with appointment booking, medical records access, and telemedicine capabilities.',
    clientName: 'MedCare Clinic',
    image: '/img/Healthcare Portal.jpg',
    galleryImages: ['/img/Healthcare Portal.jpg'],
    detailFields: [
      { label: 'Portal Modules', value: 'Appointments, Records, Telemedicine', type: 'text' },
    ],
    year: '2025',
    industry: 'Healthcare',
    direction: 'Portal Experience',
  },
  {
    id: 5,
    slug: 'smart-home-app',
    title: 'Smart Home App',
    category: 'Mobile App',
    description: 'An intuitive mobile application to control and monitor smart home devices globally.',
    longDescription:
      'An intuitive mobile application to control and monitor smart home devices globally with automation rules and alerts.',
    clientName: 'Smart Living Co',
    image: 'https://images.unsplash.com/photo-1558002038-1055907df827?q=80&w=800&auto=format&fit=crop',
    galleryImages: [
      'https://images.unsplash.com/photo-1558002038-1055907df827?q=80&w=800&auto=format&fit=crop',
    ],
    detailFields: [{ label: 'App Platforms', value: 'iOS and Android', type: 'text' }],
    year: '2023',
    industry: 'IoT & Smart Living',
    direction: 'Mobile Experience',
  },
];
